$(function () {
  // 1. スライダーを初期化し、変数に格納
  var slider = $('.gallery-slider').slick({
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    speed: 2000
  });
  
  // 2. スライダーの状態が変わる直前（beforeChange）の処理
  slider.on('beforeChange', function (event, slick, current_slide_index, next_slide_index) {
    // 💡 サムネイルのクラスセレクタを修正
    $('.gallery-slider-thumb-list-item').removeClass('slick-current');
    $('.gallery-slider-thumb-list-item:eq(' + next_slide_index + ')').addClass('slick-current');
  });
  
  // 3. サムネイルクリック時の処理
  // 💡 クリックイベントのセレクタを修正 (li要素に変更)
  $('.gallery-slider-thumb-list-item').on('click', function () {
    // クリックされたアイテムのインデックスを取得
    var index = $('.gallery-slider-thumb-list-item').index(this);
    
    // メインスライダーをそのインデックスに移動
    slider.slick('slickGoTo', index);
    
    // オートプレイを一時停止
    slider.slick('slickPause'); 
    
    // 💡 クリックしたアイテムに即座にslick-currentクラスを付ける（任意）
    $('.gallery-slider-thumb-list-item').removeClass('slick-current');
    $(this).addClass('slick-current');
  });
  
  // 4. 初期ロード時のカレントクラス設定
  $('.gallery-slider-thumb-list-item:eq(0)').addClass('slick-current');
});